import React from 'react'
import { BasicStatsItem } from '../index.styles'

const NaturalResources = () => {
  const link = 'https://app.powerbi.com/view?r=eyJrIjoiYjllNDEyN2MtMDUyYy00MGZkLTkzMmItZjA0MDc4N2VmMTZmIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'
  return (
    <BasicStatsItem
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        flex: '1',
        minHeight: 'calc(100vh - 4.4rem)'
      }}>
      <iframe title="Natural resources iframe" src={link} />
    </BasicStatsItem>
  )
}

export default NaturalResources